import type { FC } from "react";

import type { AntCustomFormField } from "../../../Form/types/types";

interface DisplayTextProps extends AntCustomFormField<string> {}

export const DisplayText: FC<DisplayTextProps> = ({ value }) => {
    return <div>{value}</div>;
};
